import request from 'axios';
import idx from 'idx';
import { ADD_COMMENT_SUCCESS, ADD_COMMENT_REPLY_SUCCESS } from 'project/ducks/common';

/* ACTIONS
================================================================================================ */
export const FETCH = 'crowdspring/admin/FETCH_PROJECT_ENTRY';
export const FETCH_SUCCESS = 'crowdspring/admin/FETCH_PROJECT_ENTRY_SUCCESS';

export const FETCH_COMMENTS = 'crowdspring/admin/FETCH_PROJECT_REVISION_COMMENTS';
export const FETCH_COMMENTS_REQUEST = 'crowdspring/admin/FETCH_PROJECT_REVISION_COMMENTS_REQUEST';
export const FETCH_COMMENTS_SUCCESS = 'crowdspring/admin/FETCH_PROJECT_REVISION_COMMENTS_SUCCESS';

export const SET_CURRENT_REVISION = 'crowdspring/admin/SET_CURRENT_PROJECT_REVISION';

export const ZOOM_IN = 'crowdspring/admin/PROJECT_ENTRY_ZOOM_IN';
export const ZOOM_OUT= 'crowdspring/admin/PROJECT_ENTRY_ZOOM_OUT';


/* HELPERS
================================================================================================ */
export const MAX_ZOOM_SCALE = 8;

/* INITIAL STATES
================================================================================================ */
export const initialState = {
  entry: null,
  comments: [],
  zoom: 1,
  scaleLevel: 4
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  let newScale;

  switch (action.type) {
    case FETCH_SUCCESS:
      return {
        ...state,
        entry: action.payload,
        currentRevisionId: action.currentRevisionId || idx(action.payload, _ => _.revisions[0].id)
      };
    case FETCH_COMMENTS_REQUEST:
      return {
        ...state,
        comments: []
      };
    case FETCH_COMMENTS_SUCCESS:
      return {
        ...state,
        comments: action.payload
      };
    case ADD_COMMENT_SUCCESS:
      return {
        ...state,
        comments: [...state.comments, action.payload]
      };
    case ADD_COMMENT_REPLY_SUCCESS:
      return {
        ...state,
        comments: state.comments.map(comment => {
          if (comment.id === action.payload.reply_to) {
            return {
              ...comment,
              replies: [...comment.replies, action.payload]
            };
          }
          return comment;
        })
      };
    case SET_CURRENT_REVISION:
      return {
        ...state,
        currentRevisionId: action.payload
      };
    case ZOOM_IN:
      newScale = Math.min(state.scaleLevel + 1, MAX_ZOOM_SCALE);
      return {
        ...state,
        scaleLevel: newScale,
        zoom: newScale * 0.25
      };
    case ZOOM_OUT:
      newScale = Math.max(state.scaleLevel - 1, 0);
      return {
        ...state,
        scaleLevel: newScale,
        zoom: newScale * 0.25
      };
    default:
      return state;
  }
}

export const fetch = (projectId, currentRevisionId, id) => (dispatch) => {
  return dispatch({
    type: FETCH,
    promise: request.get(`/api/v1/projects/${projectId}/entries/${id}/`),
    currentRevisionId
  });
};

export const fetchComments = (entryType, revisionId) => (dispatch) => {
  dispatch({
    type: FETCH_COMMENTS,
    promise: request.get(
      `/api/v1/project-${entryType}-entry-revisions/${revisionId}/comments/`
    )
  });
}

export const setCurrentRevision = (revisionId) => (dispatch, getState) => {
  dispatch({
    type: SET_CURRENT_REVISION,
    payload: revisionId
  });
}

export const zoomIn = () => {
  return {
    type: ZOOM_IN
  };
}

export const zoomOut = () => {
  return {
    type: ZOOM_OUT
  };
}
